import { render } from "./Modal.vue?vue&type=template&id=04861c62&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=04861c62&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04861c62"]])

export default __exports__